module.exports = __webpack_public_path__ + "subscribe.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./app/subscribe.html
// module id = 101
// module chunks = 0